import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { zodPaginatedResponseSchema } from '@vestigas/data';

import { toSnakeCase, withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import { ORDER_BY } from './constants';

export const zodCompanyAccountsQueryParamsSchema = z
  .object({
    limit: z
      .number()
      .gte(1)
      .max(100)
      .optional()
      .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
    offset: z.number().nonnegative().optional().prefault(0),
    orderBy: z
      .preprocess(
        (value) => (typeof value === 'string' ? toSnakeCase(value) : 'name'),
        z.enum(ORDER_BY),
      )
      .optional()
      .prefault('name'),
    returnTotalCount: z.boolean().optional().prefault(true),
    searchString: z.string().optional().prefault(''),
    sortOrder: z
      .preprocess(
        (value) => String(value).toUpperCase(),
        z.enum(['ASC', 'DESC']),
      )
      .optional()
      .prefault('ASC'),
  })
  .transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
  );

/**
 * `VAdminCompanyAccount` in the OpenAPI spec — the VESTIGAS-admin list view,
 * with aggregated company flags. Distinct from the richer `CompanyAccount`
 * shape (`companies[]`, `data`) returned by the single-account GET endpoint
 * and modeled in `useQueryCompanyAccount/validations.ts`; the two are not the
 * same schema despite sharing a tag.
 */
export const zodCompanyAccountSchema = z.object({
  hasBlacklistedCompany: z.boolean().nullish(),
  hasReceiverCompany: z.boolean().nullish(),
  hasSenderCompany: z.boolean().nullish(),
  id: z.uuid(),
  name: z.string(),
  syncKey: z.string().nullish(),
});

export const zodCompanyAccountsResponseSchema = zodPaginatedResponseSchema(
  zodCompanyAccountSchema,
);
